import { render, staticRenderFns } from "./fincodePayment.vue?vue&type=template&id=23d98074&scoped=true"
import script from "./fincodePayment.vue?vue&type=script&lang=js"
export * from "./fincodePayment.vue?vue&type=script&lang=js"
import style0 from "./fincodePayment.vue?vue&type=style&index=0&id=23d98074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d98074",
  null
  
)

export default component.exports